export const ROOT_ELEMENT_SELECTOR = '#root';
export const SVG_ICON_SELECTOR = 'svg';
export const DEFAULT_COLOR = '#faad4d';
